module.exports = __webpack_public_path__ + "static/media/ab8.f17606e3.png";